import {
  Accordion,
  Button,
  Card,
  Icon,
  Label,
  List,
  ListContent,
  ListDescription,
  ListItem,
  Segment,
} from "semantic-ui-react";
import { useState } from "react";
import { RegisterAssignment } from "../models/RegisterAssignment";
import { PermitType } from "../models/PermitType";
import { LicenceType } from "../models/globalTypes";

interface Props {
  registerAssignments?: RegisterAssignment[];
  permitTypes?: PermitType[] | null;
  onAddRegisterAssignmentsClick: (permitTypeId: string) => void;
  onDeleteRegisterAssignment: (id: string) => void;
}

const PermitRegisterTypesGrid = ({
  registerAssignments,
  permitTypes,
  onAddRegisterAssignmentsClick,
  onDeleteRegisterAssignment,
}: Props) => {
  const [activeIndex, setActiveIndex] = useState<string | undefined>(undefined);

  const handleAddAssignmentClick = (permitTypeId: string) => {
    onAddRegisterAssignmentsClick(permitTypeId);
  };

  const renderRegisterAssignmentCard = (a: RegisterAssignment) => {
    return (
      <Card key={a.id} fluid style={{ boxShadow: "0px 0px", marginTop: "0px" }}>
        <Card.Content style={{ padding: "0px 0px" }}>
          <Button
            circular
            icon="close"
            floated="right"
            style={{ padding: "2px", "box-shadow": "0px 0px" }}
            onClick={() => onDeleteRegisterAssignment(a.id)}
          ></Button>
          {a.orgUser.user.displayName}
          <p>{a.orgUser.user.email}</p>
        </Card.Content>
      </Card>
    );
  };

  const renderRoleGroup = (role: string, assignments: RegisterAssignment[]) => {
    return (
      <Segment key={role} basic style={{ border: "1px solid #ddd" }}>
        <Label attached="top">{role}</Label>
        {assignments.map(renderRegisterAssignmentCard)}
      </Segment>
    );
  };

  const renderPermitType = (permitType: PermitType) => {
    const typeAssignments =
      registerAssignments?.filter(
        (a) =>
          a.permitTypeOrgRole.permitType.id === permitType.id &&
          a.permitTypeOrgRole.orgRole.licenceType !== LicenceType.VIEWER,
      ) ?? [];

    const roleGroups = Array.from(new Set(typeAssignments.map((a) => a.permitTypeOrgRole.orgRole.displayName)));

    return (
      <ListItem key={permitType.id}>
        <ListContent>
          <ListDescription>
            <Accordion>
              <Accordion.Title
                active={activeIndex === permitType.id}
                onClick={() => setActiveIndex(activeIndex === permitType.id ? undefined : permitType.id)}
              >
                <Card fluid style={{ boxShadow: "0px 0px" }}>
                  <Label ribbon style={{ marginRight: "-28px" }}>
                    <Icon name="dropdown" /> {permitType.name} ({typeAssignments.length})
                    <Button
                      basic
                      style={{ padding: "0px", "box-shadow": "0px 0px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddAssignmentClick(permitType.id);
                      }}
                      floated="right"
                    >
                      + Add assignment
                    </Button>
                  </Label>
                </Card>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === permitType.id}>
                {roleGroups.length > 0 ? (
                  roleGroups.map((role) =>
                    renderRoleGroup(
                      role,
                      typeAssignments.filter((a) => a.permitTypeOrgRole.orgRole.displayName === role),
                    ),
                  )
                ) : (
                  <p style={{ color: "#888" }}>No assignments yet.</p>
                )}
              </Accordion.Content>
            </Accordion>
          </ListDescription>
        </ListContent>
      </ListItem>
    );
  };

  return (
    <>
      <List relaxed>{permitTypes?.map(renderPermitType)}</List>
    </>
  );
};

export default PermitRegisterTypesGrid;
